import React from "react";
import { Col, Row } from "antd";
import style from "../../index.module.scss";
import Form from "rc-field-form";
import Editor from "components/Editor";

export default function FieldAnalysis() {
    return (
        <Row gutter={[0, 20]}>
            <Col span={4} className={style.label}>
                参考答案{" "}
                <div className={style.tip}>
                    (参考答案在活动结束之前不会显示给学生)
                </div>
            </Col>

            <Col span={18} offset={1}>
                <Form.Field
                    name="analysis"
                    valuePropName="data"
                    initialValue="">
                    <Editor data="" />
                </Form.Field>
            </Col>
        </Row>
    );
}
